<template>
    <div>
        <container-view titulo="Lista de usuarios" classCard="bg-white" :isCard="true">
            <template v-slot:top>
                <div class="d-flex col-12 justify-content-end mb-4">
                    <router-link :to="{name: 'CrearUsuario'}" class="btn btn-primary col-12 col-sm-auto"><i class="fa fa-plus me-2"></i>Agregar Usuario</router-link>
                </div>
            </template>
            <template v-slot:body>
                <data-list :fields="fields" :datas="usuarios" @evento="verCliente($event)"></data-list>
            </template>
        </container-view>
    </div>
</template>
<script setup>
import ContainerView from '@/components/admin/template/Container'
import DataList from '@/components/admin/template/DataList'
import { ref, onMounted, watchEffect } from 'vue'
import { useRouter } from 'vue-router'
import User from '@/components/admin/usuario/user'
import Fecha from '@/components/utils/fecha'
const fields = [
    {
        titulo: 'Nombre:',
        key: 'name',
        clase: 'text-primary',
        claseTitulo: "text-success"
    },
    {
        titulo: 'Email:',
        key: 'email',
    },
    {
        titulo: 'Creado:',
        key: 'created_at',
    }
]
const usuarios = ref()
const router = useRouter()
onMounted(async()=>{
    await User.getAllUsers().then( e => usuarios.value = e.usuarios )
    watchEffect(()=>{
        usuarios.value.filter((e)=> e.created_at = Fecha.formatDate(e.created_at, "DD/MM/YYYY"))
    })
})

const verCliente = data => router.push({name: 'VerUsuarioAdmin', params: {id: data.id}})

</script>